import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { SettingsManagementService } from 'src/app/core/services/system-services/settings-management.service';
import * as settings from 'src/app/store/settings';

@Component({
  selector: 'oops-nav-menu-toggle',
  templateUrl: './nav-menu-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavMenuToggleComponent {
  @Input() minified: boolean;

  constructor(private store: Store<any>,
    private settingService: SettingsManagementService) { }

  toggleMinifyNavigation($event: MouseEvent) {
    this.settingService.observeMinifyState()
      .subscribe(minifyState => {
        this.store.dispatch(settings.toggleMinifyNavigation({
          minifyNavigation: !minifyState
        }));
      })
  }
}
